"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Emailcaptures(_a) {
    var id = _a.id, user = _a.user;
    var params = {
        id: id,
        channel_id: id,
        details: true,
    };
    var model = {
        id: null,
        channel_id: id,
        name: '',
        logo: '',
        options: {
            ecapture: false,
            ecapture_title: '',
            ecapture_time: '',
        },
    };
    var _b = storybook_1.Helpers.useSave('backend', 'channels', model, params), channel = _b[0], setChannel = _b[1], saveChannel = _b[2];
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return react_1.default.createElement("div", { className: 'storybook-pages-ecaptures-save' },
        react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-pages-ecaptures-save-wrapper' },
            react_1.default.createElement(storybook_1.Layouts.Main, { className: 'mb-4 md:mb-0 col-span-12 md:col-span-5' },
                react_1.default.createElement(storybook_1.Ecaptures.Form, { user: user, setChannel: setChannel, channel: channel, submit: saveChannel })),
            react_1.default.createElement("div", { className: 'col-span-12 md:col-span-7 md:ml-4 relative' },
                react_1.default.createElement("div", { className: 'bg-black absolute inset-0 opacity-25 z-40 cursor-not-allowed' }),
                react_1.default.createElement(storybook_1.Ecaptures.PlayerForm, { channel: channel.data, dashboard: true }))));
}
exports.default = Emailcaptures;
